import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Typography, Grid, Box, Button, Menu, MenuItem } from '@mui/material';
import { TbHeartFilled, TbDots, TbVideo, TbPlus, TbFileText, TbMusic, TbCalendar, TbLink } from 'react-icons/tb';
import { BiSolidBadgeCheck } from 'react-icons/bi';
import { BsFillPinAngleFill } from 'react-icons/bs';
import ConfettiExplosion from 'react-confetti-explosion';
import {RiFullscreenFill} from 'react-icons/ri';
import { MdCalendarToday, MdAccessTime, MdPeople } from 'react-icons/md';
import VideoJS from '../../common/VideoJS';
import {FaLink} from 'react-icons/fa';
import ReactAudioPlayer from "react-audio-player";
import PDFSwiper from "../../Content/ContentSubComponents/PDFs/PDFSwiper";
import { pdfjs } from 'react-pdf';
import ZoomImage from '../../../media/site_media/platform-icons/zoom.png';
import MicrosoftTeams from '../../../media/site_media/platform-icons/microsoft-teams.png';
import GoogleMeetImage from '../../../media/site_media/platform-icons/google-meet.png';
import GoogleSheetsImage from '../../../media/site_media/platform-icons/google-sheets.png';
import GoogleDocsImage from '../../../media/site_media/platform-icons/google-docs.png';
import EventPost from './EventPost';
import { FaHourglassHalf } from 'react-icons/fa';
import { timeDeltaToString } from '../../common/timeDelta';
import { normalizeExternalHref } from '../../../utils/normalizeExternalHref';
const paths = require("../../../paths.json");

// Set the worker source for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function getTimeDelta(timeString, t) {
   const now = new Date();
   const postTime = new Date(timeString);
   const diffInMs = now - postTime;
   const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
   const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
   const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

   if (diffInMinutes < 1) {
      return t('community.post.timeDelta.justNow');
   } else if (diffInMinutes < 60) {
      return t('community.post.timeDelta.minutesAgo', { minutes: diffInMinutes });
   } else if (diffInHours < 24) {
      return t('community.post.timeDelta.hoursAgo', { hours: diffInHours });
   } else {
      return t('community.post.timeDelta.daysAgo', { days: diffInDays });
   }
}

const formatCategoryLabel = (category) => {
   if (!category) return '';
   if (category.toLowerCase() === 'all') return 'All';
   return category
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
};

function TruncateWithEllipsis(text, maxLength) {
   if (text.length <= maxLength) {
      return text;
   }
   return text.substring(0, maxLength) + '...';
}

const PDFPost = React.memo(function PDFPost({pdf_src, pre_upload, fullscreen, content_width_type, handleFullscreenPDFOpen}){

   return (
      <div style={{ position: 'relative', height: 'auto', width: '400px' }}>
         <PDFSwiper pdfFile={pre_upload || fullscreen ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src} content_width_type={content_width_type} />

         <a className={'hover_modal_icon'}
            onClick={() => {
               handleFullscreenPDFOpen(pre_upload ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src, 'pdf')
            }}
         >

            {
               fullscreen ?
                  null
                  :
                  <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: content_width_type === 'post' ? '50px' : '40px', right: '10px', zIndex: '999'}}/>
            }
         </a>

      </div>
   )



})


const AudioPost = React.memo(function AudioPost({audio_src, pre_upload}){
   return (
      <div style={{
         position: 'relative',
         width: '100%',
         padding: '12px',
         backgroundColor: '#f8f9fa',
         borderRadius: '8px',
         border: '1px solid #E4EBF6',
         marginBottom: '16px'
      }}>
         <ReactAudioPlayer
            className='react-player'
            src={pre_upload ? audio_src : paths.CONTENT_CLOUDFRONT + audio_src}
            controls
            style={{ 
               width: '100%', 
               height: '40px',
               outline: 'none'
            }}
         />
      </div>
   )
})



const CommunityPostSummary = ({
   post_index,
   username,
   display_name,
   user_icon,
   time,
   subscription,
   text,
   content_file,
   content_type,
   post_like_count,
   post_tier,
   influencer_tier_names = {},
   n_threads,
   n_comments,
   threads,
    tags_list,
   onClick,
   onLike,
   post_id,
   post_user_value_count,
   link,
   pinned,
   current_user,
   influencer_name,
   handleUpdatePinnedPost,
   handleRemovePinnedPost,
   isPinnedPost,
   community_post_title,
   editPost,
   getBrandColor,
   deletePost,
   event_time,
   scheduled_date,
   hideLocation = false,
   handleEditingContentModal,
   is_example = false,
}) => {
   const { t } = useTranslation();
   const tierBadgeText = influencer_tier_names[post_tier];
   const isScheduled = !!(scheduled_date && new Date(scheduled_date) > new Date());
  const [isExploding, setIsExploding] = useState(false);
  const [explodingIndex, setExplodingIndex] = useState(null);
  const confettiColors = ['#3c55f3', '#fa87da', '#2cd983', '#f6bd50'];
  const [fullscreenPDFOpen, setFullscreenPDFOpen] = useState(false);
  const [fullscreenPDFSrc, setFullscreenPDFSrc] = useState('');
  const [fullscreenViewOpen, setFullscreenViewOpen] = useState(false);
  const primaryCategory = Array.isArray(tags_list)
    ? tags_list.find(tag => tag && tag.toLowerCase() !== 'all') || null
    : null;
  const [selectedContentFullscreen, setSelectedContentFullscreen] = useState('');
  const [selectedContentFullscreenType, setSelectedContentFullscreenType] = useState('');
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const [pdfPreviewImage, setPdfPreviewImage] = useState(null);
  const [pdfPreviewLoading, setPdfPreviewLoading] = useState(false);

  const handleFullscreenPDFOpen = (pdf_src) => {
      // console.log(pdf_src, 'opened pdf fullscreen')
      setFullscreenPDFSrc(pdf_src);
      setFullscreenPDFOpen(true);
   }
   const handleFullscreenPDFClose = () => {
      setFullscreenPDFOpen(false);
   }


   const handleFullscreenOpen = (preview_src, preview_type) => {
      // console.log(preview_src, preview_type)
      // console.log('clicked')
      setSelectedContentFullscreen(preview_src);
      setSelectedContentFullscreenType(preview_type);
      // console.log(preview_type, preview_src)
      setFullscreenViewOpen(true);
   }

   const handleFullscreenClose = () => {
      setFullscreenViewOpen(false);
   }

   // Load first page of PDF for preview
   useEffect(() => {
      const loadPdfFirstPage = async () => {
         if (content_type === 'pdf' && content_file) {
            try {
               setPdfPreviewLoading(true);
               const pdfUrl = paths.CONTENT_CLOUDFRONT + content_file;
               const pdf = await pdfjs.getDocument(pdfUrl).promise;
               const page = await pdf.getPage(1);
               const scale = 0.5; // Lower scale for thumbnail
               const viewport = page.getViewport({ scale });
               const canvas = document.createElement('canvas');
               const context = canvas.getContext('2d');
               canvas.height = viewport.height;
               canvas.width = viewport.width;

               await page.render({ canvasContext: context, viewport }).promise;
               const imageData = canvas.toDataURL('image/png');
               setPdfPreviewImage(imageData);
               setPdfPreviewLoading(false);
            } catch (error) {
               console.error('Error loading PDF preview:', error);
               setPdfPreviewLoading(false);
               setPdfPreviewImage(null);
            }
         } else {
            setPdfPreviewImage(null);
         }
      };

      loadPdfFirstPage();
   }, [content_type, content_file]);

   // Extract unique commenter avatars from threads and comments
   const getCommenterAvatars = () => {
      if (!threads || threads.length === 0) return [];
      
      const commenters = new Set();
      const avatars = [];
      
      threads.forEach(thread => {
         // Add thread author if they have an icon
         if (thread.user_icon && !commenters.has(thread.user_icon)) {
            commenters.add(thread.user_icon);
            avatars.push({
               icon: thread.user_icon,
               name: thread.username || 'Anonymous'
            });
         }
         
         // Add comment authors if they have icons
         if (thread.comments && thread.comments.length > 0) {
            thread.comments.forEach(comment => {
               if (comment.user_icon && !commenters.has(comment.user_icon)) {
                  commenters.add(comment.user_icon);
                  avatars.push({
                     icon: comment.user_icon,
                     name: comment.commenter_display_name || comment.commenter || 'Anonymous'
                  });
               }
            });
         }
      });
      
      // Return maximum 4 avatars to avoid clutter
      return avatars.slice(0, 4);
   };

   // Calculate actual thread and comment counts from threads data
   const getActualCounts = () => {
      if (!threads || threads.length === 0) {
         if (is_example) return { threadCount: n_threads || 0, commentCount: n_comments || 0 };
         return { threadCount: 0, commentCount: 0 };
      }
      
      let threadCount = threads.length;
      let commentCount = 0;
      
      threads.forEach(thread => {
         if (thread.comments && thread.comments.length > 0) {
            commentCount += thread.comments.length;
         }
      });
      
      return { threadCount, commentCount };
   };
   
   const commenterAvatars = getCommenterAvatars();
   const { threadCount, commentCount } = getActualCounts();
   
   const handleMenuOpen = (event) => {
      event.stopPropagation();
      setAnchorElMenu(event.currentTarget);
   };

  const handleMenuClose = () => {
     setAnchorElMenu(null);
  };

 const isVideoContentPreview = ['vid', 'vid-rec'].includes(content_type);
 const isEmbedContentPreview = ['vey', 'vel', 'vev', 'vtw', 'vwi'].includes(content_type);
 const isDocumentContentPreview = ['pdf', 'aud', 'god', 'gos'].includes(content_type);
 const isEventContentPreview = ['mot', 'mgm', 'mzm', 'mmt'].includes(content_type);
 const hasExamplePreview = is_example && ['img', 'vid', 'vid-rec', 'aud', 'pdf'].includes(content_type);
 const hasSidePreview = hasExamplePreview || ((content_file || link) && (content_type === 'img' || isVideoContentPreview || isEmbedContentPreview || isDocumentContentPreview) && !isEventContentPreview);

 const renderSidePreviewContent = () => {
   if (is_example && !content_file) {
      const exampleStyles = {
         img: { bg: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)', color: '#4CAF50', icon: '🖼️' },
         vid: { bg: 'linear-gradient(135deg, #F3E5F5 0%, #CE93D8 100%)', color: '#9C27B0', icon: '▶' },
         'vid-rec': { bg: 'linear-gradient(135deg, #F3E5F5 0%, #CE93D8 100%)', color: '#9C27B0', icon: '▶' },
         aud: { bg: 'linear-gradient(135deg, #FFF3E0 0%, #FFCC80 100%)', color: '#FF9800', icon: '♪' },
         pdf: { bg: 'linear-gradient(135deg, #FFEBEE 0%, #EF9A9A 100%)', color: '#F44336', icon: '📄' },
      };
      const style = exampleStyles[content_type] || exampleStyles.img;
      return (
         <div style={{
            width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: style.bg, borderRadius: '12px', fontSize: '32px', color: style.color,
         }}>
            {style.icon}
         </div>
      );
   }
   if (!content_file && !link) return null;

   if (content_type === 'img') {
     return (
       <img
         src={paths.CONTENT_CLOUDFRONT + content_file}
         alt={t('common.postContent')}
         style={{
           width: '100%',
           height: '100%',
           objectFit: 'cover',
           borderRadius: '12px',
           display: 'block'
         }}
       />
     );
   }

   if (isVideoContentPreview) {
     return (
       <video
         src={paths.CONTENT_CLOUDFRONT + content_file + '#t=0.001'}
         playsInline
         preload="metadata"
         muted
         style={{
           width: '100%',
           height: '100%',
           objectFit: 'cover',
           borderRadius: '12px',
           display: 'block'
         }}
       />
     );
   }

   if (content_type === 'vey') {
     return (
       <iframe
         title={t('community.youTubePreview')}
         src={`https://www.youtube-nocookie.com/embed/${content_file}?rel=0&modestbranding=1`}
         frameBorder="0"
         allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen"
         allowFullScreen
         style={{
           width: '100%',
           height: '100%',
           border: 'none',
           pointerEvents: 'none'
         }}
       />
     );
   }

   if (content_type === 'vel') {
     return (
       <iframe
         title={t('community.loomPreview')}
         src={`https://www.loom.com/embed/${content_file}?autoplay=false`}
         frameBorder="0"
         allowFullScreen
         style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
       />
     );
   }

   if (content_type === 'vev') {
     return (
       <iframe
         title={t('common.vimeoPlayer', 'Vimeo video player')}
         src={`https://player.vimeo.com/video/${content_file}`}
         frameBorder="0"
         allow="autoplay; fullscreen; picture-in-picture"
         allowFullScreen
         style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
       />
     );
   }


   if (content_type === 'vtw') {
     const twitchKey = content_file || '';
     const twitchSrc = twitchKey.startsWith('ch')
       ? `https://player.twitch.tv/?channel=${twitchKey.slice(2)}&parent=${window.location.hostname}`
       : twitchKey.startsWith('c')
       ? `https://clips.twitch.tv/embed?clip=${twitchKey.slice(1)}&parent=${window.location.hostname}`
       : `https://player.twitch.tv/?video=${twitchKey.slice(1)}&parent=${window.location.hostname}`;
     return (
       <iframe
         title={t('common.twitchPlayer', 'Twitch video player')}
         src={twitchSrc}
         frameBorder="0"
         allow="autoplay; fullscreen"
         allowFullScreen
         style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
       />
     );
   }

   if (content_type === 'vwi') {
     return (
       <iframe
         title={t('common.wistiaPlayer', 'Wistia video player')}
         src={`https://fast.wistia.com/embed/iframe/${content_file}?autoPlay=false`}
         frameBorder="0"
         allow="autoplay; fullscreen"
         allowFullScreen
         style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
       />
     );
   }

   if (content_type === 'pdf') {
     if (pdfPreviewLoading) {
       return (
         <div style={{
           width: '100%',
           height: '100%',
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'center',
           alignItems: 'center',
           backgroundColor: '#f8f9fa',
           borderRadius: '12px',
           padding: '16px'
         }}>
           <TbFileText style={{ fontSize: '48px', color: '#dc3545', marginBottom: '8px' }} />
           <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>{t('community.composer.loading')}</span>
         </div>
       );
     }
     
     if (pdfPreviewImage) {
       return (
         <img
           src={pdfPreviewImage}
           alt={t('common.pdfPreview')}
           style={{
             width: '100%',
             height: '100%',
             objectFit: 'cover',
             borderRadius: '12px',
             display: 'block'
           }}
         />
       );
     }
     
     // Fallback to icon if image failed to load
     return (
       <div style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         alignItems: 'center',
         backgroundColor: '#f8f9fa',
         borderRadius: '12px',
         padding: '16px'
       }}>
         <TbFileText style={{ fontSize: '48px', color: '#dc3545', marginBottom: '8px' }} />
         <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>{t('community.post.content.pdfDocument')}</span>
       </div>
     );
   }

   if (content_type === 'aud') {
     return (
       <div style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         alignItems: 'center',
         backgroundColor: '#fff',
         borderRadius: '12px',
         padding: '8px'
       }}>
         <ReactAudioPlayer
           className='react-player'
           src={paths.CONTENT_CLOUDFRONT + content_file}
           controls
           style={{ 
             width: '100%', 
             height: '32px',
             outline: 'none'
           }}
         />
       </div>
     );
   }

   if (content_type === 'god') {
     return (
       <div style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         alignItems: 'center',
         borderRadius: '12px',
         padding: '16px'
       }}>
         <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '48px', height: '48px', marginBottom: '8px' }} />
         <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>{t('dashboard.paidDms.googleDocs')}</span>
       </div>
     );
   }

   if (content_type === 'gos') {
     return (
       <div style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         alignItems: 'center',
         borderRadius: '12px',
         padding: '16px'
       }}>
         <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '48px', height: '48px', marginBottom: '8px', objectFit: 'contain'}} />
         <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>{t('dashboard.paidDms.googleSheets')}</span>
       </div>
     );
   }

   if (isEventContentPreview) {
     let eventIcon = null;
     let eventName = t('community.post.event');
     
     const getMeetingBackgroundColor = () => {
       if (content_type === 'mgm') return '#FFF6DC'; // Google Meet
       if (content_type === 'mzm') return '#E5F1FF'; // Zoom
       if (content_type === 'mmt') return '#E6E7FF'; // Microsoft Teams
       return '#F9FBFF'; // Default for 'mot' (Other Meeting)
     };
     
     if (content_type === 'mzm') {
       eventIcon = <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '80px', height: 'auto',  }} />;
       eventName = t('community.composer.zoomMeeting');
     } else if (content_type === 'mgm') {
       eventIcon = <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: 'auto', height: '60px', }} />;
       eventName = t('community.composer.googleMeet');
     } else if (content_type === 'mmt') {
       eventIcon = <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: 'auto', height: '48px', }} />;
       eventName = t('community.composer.microsoftTeams');
     } else if (content_type === 'mot') {
       eventIcon = <TbLink style={{ fontSize: '48px', color: '#6C89AF', }} />;
       eventName = t('community.post.event');
     }

     return (
       <div style={{
         width: '100%',
         height: '100%',
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         alignItems: 'center',
         backgroundColor: getMeetingBackgroundColor(),
         borderRadius: '12px',
         padding: '16px'
       }}>
         {eventIcon}
         {/* <span style={{ fontSize: '12px', color: '#666', fontWeight: '500', textAlign: 'center' }}>{eventName}</span> */}
       </div>
     );
   }

   return null;
 };

   return (
      <div 
         onClick={() => onClick(post_index)}
         style={{
            padding: '16px',
            position: 'relative',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
            boxShadow: pinned 
               ? '0 1px 3px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(60, 85, 243, 0.30), 0 0 16px rgba(60, 85, 243, 0.12)' 
               : '0 1px 3px rgba(0, 0, 0, 0.05)',
            
         }}
      >
        <div style={{ position: 'relative' }}>
          {/* 3 dots menu and pinned icon */}
          <div style={{ position: 'absolute', top: '0px', right: '0px', display: 'flex', alignItems: 'center', gap: '8px', zIndex: 5 }}>
            {pinned && (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <BsFillPinAngleFill style={{ fontSize: '14px', color: 'var(--brand-color)' }} />
                <span style={{ fontSize: '12px', color: 'var(--brand-color)', fontWeight: '600' }}>{t('community.post.pinned')}</span>
              </span>
            )}
            {(current_user && (current_user === influencer_name || current_user === username)) && (
              <>
                <span
                  onClick={handleMenuOpen}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '4px',
                    borderRadius: '4px',
                    transition: 'background 0.15s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                >
                  <TbDots style={{ fontSize: '20px', color: '#666' }} />
                </span>
                <Menu
                  anchorEl={anchorElMenu}
                  open={Boolean(anchorElMenu)}
                  onClose={handleMenuClose}
                  onClick={(e) => e.stopPropagation()}
                  autoFocus={false}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: "#fff",
                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px',
                      border: '1px #f4f4f4 solid'
                    },
                    "& .MuiMenuItem-root": {
                      "&:focus": {
                        backgroundColor: "transparent"
                      },
                      "&.Mui-focusVisible": {
                        backgroundColor: "transparent"
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5"
                      }
                    }
                  }}
                >
                  {/* Pin/Remove Pin - Only for influencer */}
                  {(!pinned && current_user === influencer_name && !isPinnedPost) && (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (handleUpdatePinnedPost) {
                          handleUpdatePinnedPost(post_id, post_index);
                        }
                        handleMenuClose();
                      }}
                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}
                    >
                      {t('community.post.menu.pin')}
                    </MenuItem>
                  )}
                  {(pinned && current_user === influencer_name) && (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (handleRemovePinnedPost) {
                          handleRemovePinnedPost(post_id, post_index);
                        }
                        handleMenuClose();
                      }}
                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}
                    >
                      {t('community.post.menu.removePin')}
                    </MenuItem>
                  )}
                  {/* Edit - For post author or influencer - Opens edit modal directly */}
                  {(current_user === influencer_name || current_user === username) && editPost && (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        // Open the post in edit mode directly
                        if (onClick) {
                          onClick(post_index, true);
                        }
                        handleMenuClose();
                      }}
                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}
                    >
                      {t('community.post.menu.edit')}
                    </MenuItem>
                  )}
                  {/* Delete - For post author or influencer */}
                  {(current_user === influencer_name || current_user === username) && deletePost && (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        if (deletePost) {
                          deletePost(post_id, post_index);
                        }
                        handleMenuClose();
                      }}
                      sx={{ color: 'var(--danger-color)', fontWeight: '500', fontSize: '14px' }}
                    >
                      {t('community.post.menu.delete')}
                    </MenuItem>
                  )}
                </Menu>
              </>
            )}
          </div>

          {isScheduled && (
            <div style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 4,
              backgroundColor: 'rgba(24, 24, 24, 0.7)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              borderRadius: '1000px',
              pointerEvents: 'none',
            }}>
              <div style={{ display: 'flex', padding: '10px 20px' }}>
                <FaHourglassHalf style={{ fontSize: '16px', color: '#fff', margin: 'auto auto auto auto' }} />
                <span style={{ color: '#fff', fontSize: '14px', fontWeight: '700', margin: 'auto auto auto 10px', whiteSpace: 'nowrap' }}>
                  {t('common.liveIn', { time: timeDeltaToString(new Date(), new Date(scheduled_date)) })}
                </span>
              </div>
            </div>
          )}

          <div style={isScheduled ? { filter: 'blur(4px)' } : undefined}>

          {/* Header section - full width */}
          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px', paddingRight: '60px' }}>
            <Avatar 
              alt={username} 
              src={user_icon} 
              style={{ 
                marginRight: '12px', 
                width: '44px', 
                height: '44px',
                border: '2px solid #f0f0f0'
              }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: '0px' }}>
                <Typography 
                  variant="subtitle2" 
                  style={{ 
                    fontWeight: 'bold', 
                    marginRight: '2px',
                    fontSize: '16px'
                  }}
                >
                  {TruncateWithEllipsis(display_name, 20)}
                </Typography>
                
                {subscription === 'Creator' && (
                    <BiSolidBadgeCheck style={{  fontSize: '14px', color: getBrandColor() }}/>
                )}
                
                {post_tier > 0 && (
                  <span
                    style={{
                      margin: '0px 8px 0px 0px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      backgroundColor: '#e1e4ff',
                      color: 'var(--brand-color)',
                      padding: '2px 6px',
                      fontSize: '10px',
                      fontWeight: '600',
                      borderRadius: '50px',
                    }}
                  >
                    {TruncateWithEllipsis(tierBadgeText, 16)}
                  </span>
                )}
              </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '2px', flexWrap: 'wrap' }}>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '12px' }}
              >
                {getTimeDelta(time, t)}
              </Typography>
              {primaryCategory && (
     <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px' }}>
     {formatCategoryLabel(primaryCategory)}
     </Typography>
              )}
            </div>
            </div>
          </div>

          {/* Content section - text and preview side by side */}
          <Grid container alignItems="flex-start">
            <Grid xs={hasSidePreview ? 8 : 12}>
              {(!hasSidePreview && link && ['mot', 'mgm', 'mzm', 'mmt'].includes(content_type)) ? null : (
                <Typography 
                  variant="body2" 
                  style={{
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                    fontSize: '15px',
                    lineHeight: '1.5',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#1D1D1D',
                    marginTop: '8px',
                    paddingRight: hasSidePreview ? '16px' : '60px'
                  }}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
            </Grid>
            {hasSidePreview && (
              <Grid xs={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '100%',
                    maxWidth: '180px',
                    aspectRatio: '16/9',
                    minHeight: '100px',
                    position: 'relative',
                    borderRadius: '12px',
                    border: content_type === 'aud' ? 'none' : '1px solid #E4EBF6',
                    overflow: 'hidden',
                    background: content_type === 'god' ? '#DEF1FF' : (content_type === 'gos' ? '#DEFFE9' : '#f3f3f3'),
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  {renderSidePreviewContent()}
                </div>
              </Grid>
            )}
          </Grid>
          <div style={{ width: '100%' }}>
            <>
              {/* Only show full-width content if not displayed as side preview */}
              {!hasSidePreview && (content_file || (link && ['god', 'gos'].includes(content_type))) &&
                <div style={{ position: 'relative', padding: '0px 0px 0px 0px', }}>
                  {['gos', 'god'].includes(content_type) &&
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '60px',
                        border: '1px solid #E4EBF6',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        padding: '0 16px',
                        marginBottom: '16px',
                        position: 'relative'
                      }}
                    >
                      {content_type === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                      {content_type === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                      <Box sx={{ flexGrow: 1 }}>
                        <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                          {content_type === 'gos' && t('community.post.googleSheets')}
                          {content_type === 'god' && t('community.post.googleDocs')}
                        </p>
                      </Box>

                      <Button
                        variant="contained"
                        disableElevation
                        onClick={() => handleFullscreenOpen(normalizeExternalHref(link), content_type)}
                        rel="noopener noreferrer"
                        sx={{
                          padding: '5px 7px',
                          display: 'inline-block',
                          marginLeft: 'auto',
                          borderRadius: '8px !important',
                          textTransform: 'none',
                          textAlign: 'center',
                          backgroundColor: 'var(--brand-color)',
                          '&:hover': {
                            backgroundColor: 'var(--brand-color-hover)'
                          },
                          cursor: 'pointer'
                        }}>
                        <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                          {t('community.post.actions.open')}
                        </span>
                      </Button>
                    </Box>
                  }
                  {content_type === 'aud' &&
                    <div style={{ position: 'relative', height: 'auto', width: '100%', maxWidth: '600px' }}>
                      <AudioPost audio_src={content_file}/>
                    </div>
                  }
                  {content_type === 'pdf' &&
                    <>
                      <PDFPost fullscreen={fullscreenViewOpen} pdf_src={content_file} content_width_type={'post'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                    </>
                  }
                </div>
              }
              {!hasSidePreview && (link && ['mot', 'mgm', 'mzm', 'mmt'].includes(content_type)) &&
                <div style={{ position: 'relative', padding: '0px', margin: '20px auto', width: '100%' }} onClick={(e) => e.stopPropagation()}>
                  <EventPost
                    content_type={content_type}
                    link={link}
                    text={text}
                    community_post_title={community_post_title}
                    time={event_time || time}
                    post_id={post_id}
                    imageSrc={content_file ? (paths.CONTENT_CLOUDFRONT + content_file) : null}
                    hideLocation={hideLocation}
                    is_example={is_example}
                  />
                </div>
              }
            </>
          </div>
          <Grid container>
            <Grid xs={12}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '12px',
                gap: '15px',
                paddingTop: '8px',
              }}>
              <div 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '6px',
                  backgroundColor: post_user_value_count === 1 ? '#eaebfd' : 'transparent',
                  padding: '2px 6px',
                  borderRadius: '50px',
                  transition: 'background-color 0.15s ease'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof onLike === 'function' && post_id !== undefined) {
                    if (post_user_value_count === 0) {
                      setExplodingIndex(post_id);
                      setIsExploding(true);
                    }
                    onLike(post_id, post_index);
                  }
                }}
              >
                <span style={{ fontSize: '16px', color: post_user_value_count === 1 ? 'var(--brand-color)' : '#222' }}>👍</span>
                <Typography variant="caption" style={{ color: post_user_value_count === 1 ? 'var(--brand-color)' : '#666', fontSize: '13px', fontWeight: '600' }}>
                  {post_like_count}
                </Typography>
                {isExploding && explodingIndex === post_id && (
                  <ConfettiExplosion 
                    zIndex={2000}
                    onComplete={() => { setExplodingIndex(null); setIsExploding(false); }}
                    duration={2300}
                    force={0.15}
                    particleCount={10}
                    width={180}
                    particleSize={6}
                    colors={confettiColors}
                  />
                )}
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '16px' }}>💬</span>
                <Typography variant="caption" style={{ color: '#666', fontSize: '13px', fontWeight: '500' }}>
                  {t('community.post.replies', { count: threadCount + commentCount })}
                </Typography>
                {/* Commenter avatars */}
                {commenterAvatars.length > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                    {commenterAvatars.map((commenter, index) => (
                      <Avatar
                        key={index}
                        alt={commenter.name}
                        src={commenter.icon}
                        style={{
                          width: '24px',
                          height: '24px',
                          marginLeft: index > 0 ? '-8px' : '0px',
                          // border: '2px solid #fff',
                          fontSize: '10px',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                        }}
                      />
                    ))}
                    {commenterAvatars.length === 4 && (
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: '#f0f0f0',
                        // border: '2px solid #fff',
                        marginLeft: '-8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        color: '#666',
                        fontWeight: '500'
                      }}>
                        +
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            </Grid>
          </Grid>
          </div>
        </div>
      </div>
   );
};

export default CommunityPostSummary;
